import * as React from "react";
import { Scrollbars } from "react-custom-scrollbars";
import styled from "styled-components";
import { Locale } from "@linkfluence/models/locale";
import Tabs from "@ui-kit/tabs";
import { tr } from "@radarly/i18n";

const Container = styled.div`
  display: block;
`;

type Tab = "workspaces" | "queries";

interface IProps {
  children: React.ReactNode;
  locale: Locale;
  onChange?: (tab: Tab) => void;
  tab?: Tab;
  height?: number;
}

const NavigationSwitcherSearch = ({
  children,
  locale,
  tab,
  onChange,
  height = 500,
}: IProps) => {
  const tabs = [
    {
      value: "workspaces",
      label: tr(locale, "SWITCHER::SEARCH_TAB_DASHBOARDS"),
    },
    { value: "queries", label: tr(locale, "SWITCHER::SEARCH_TAB_QUERIES") },
  ];

  return (
    <Container>
      <Tabs
        tabs={tabs}
        defaultValue={tab}
        onValueChange={onChange}
        stretch={false}
      />
      <Scrollbars autoHeight autoHeightMax={height - 42}>
        {children}
      </Scrollbars>
    </Container>
  );
};

export default NavigationSwitcherSearch;
